import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';
import { MultipleChoiceDetails, SelectDetails } from './types';
import useHook from '../hooks';

const componentDetailsMap = {
  3: SelectDetails,
  9: MultipleChoiceDetails,
};

const Index = props => {
  const { isInEdit, item, handleSave, handleChange, handleCancel, handleBack } = useHook(props);
  const isShowSave = isInEdit && props.meta.touched && !props.meta.error;
  const isShowCancel = isInEdit;

  const Component = componentDetailsMap[item.typeId];
  return (
    <div className={styles.details}>
      <Component
        item={item}
        meta={props.meta}
        index={props.index}
        default={props.default}
        onChange={handleChange}
        onSave={() => {
          handleSave();
          if (!item.parentId) {
            props.onSave();
          }
        }}
        onCancel={() => {
          handleCancel();
          if (!item.parentId) {
            props.onCancel();
          }
        }}
        onBack={() => {
          handleBack();
        }}
        onClose={props.onDetailsClose}
        isShowSave={isShowSave}
        isShowCancel={isShowCancel}
        isShowButtons={!item.parentId}
        anyTouched={props.anyTouched}
      />
    </div>
  );
};

Index.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  meta: PropTypes.objectOf(PropTypes.any).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  default: PropTypes.objectOf(PropTypes.any).isRequired,
  index: PropTypes.number.isRequired,
  anyTouched: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onDetailsClose: PropTypes.func.isRequired,
};

export default Index;
